// components/Teams/MemberDetailsModal.js
import React from 'react';
import config from '../../../config';
import HealthMatrixDashboard from '../../../components/Dashboard/dashboard/HealthMetricsDashboard/HealthMetricsDashboard'

const MemberDetailsModal = ({ member, onClose, currentUserId, token }) => {
  const isCurrentUserFriend = member?.is_friend;
  const isCurrentUser = member?.user_id === currentUserId;
  const canViewDetails = isCurrentUserFriend || isCurrentUser;

  return (
    <div className="teams-modal-overlay">
      <div className="teams-modal teams-modal-xl">
        <div className="teams-modal-header">
          <h2>Member Details</h2>
          <button 
            className="teams-modal-close"
            onClick={onClose}
          >
            &times;
          </button>
        </div>
        <div className="teams-modal-body">
          <div className="member-details-header">
            <div className="member-avatar-large">
              <img 
                src={`${config.baseURL}/uploads/profiles/${member.profile_image}` || '/images/no-image-found.webp'} 
                alt={`${member.first_name} ${member.last_name}`}
                onError={(e) => {
                  e.target.src = '/images/no-image-found.webp';
                }}
              />
            </div>
            <div className="member-title">
              <h3>{member.first_name} {member.last_name}</h3>
              <p className="member-profession-large">{member.profession || 'No profession'}</p>
              {!canViewDetails && (
                <div className="friend-required-note">
                  <p>Add this user as friend to see complete details</p>
                </div>
              )}
            </div>
          </div>
          
          {canViewDetails ? (
            <div className="member-details-grid">
              <div className="info-item">
                <span className="info-label">Email:</span>
                <span className="info-value">{member.email || 'N/A'}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Phone:</span>
                <span className="info-value">{member.phone || 'N/A'}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Qualification:</span>
                <span className="info-value">{member.qualification || 'N/A'}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Company:</span>
                <span className="info-value">{member.employer || 'N/A'}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Gender:</span>
                <span className="info-value">{member.gender || 'N/A'}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Date of Birth:</span>
                <span className="info-value">
                  {member.dob 
                    ? new Date(member.dob).toLocaleDateString() 
                    : 'N/A'}
                </span>
              </div>
              <div className="info-item">
                <span className="info-label">College:</span>
                <span className="info-value">{member.college || 'N/A'}</span>
              </div>
              <div className="info-item">
                <span className="info-label">City:</span>
                <span className="info-value">{member.city || 'N/A'}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Country:</span>
                <span className="info-value">{member.country || 'N/A'}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Added On:</span>
                <span className="info-value">
                  {new Date(member.added_at).toLocaleDateString()}
                </span>
              </div>
            </div>
          ) : (
            <div className="limited-details">
              <div className="info-item">
                <span className="info-label">Profile ID:</span>
                <span className="info-value">{member.profileId || 'N/A'}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Profession:</span>
                <span className="info-value">{member.profession || 'N/A'}</span>
              </div>
              <div className="friend-prompt">
                <p>Add this member as a friend to view their complete profile details.</p>
              </div>
            </div>
          )}
          <HealthMatrixDashboard otherUserInfo={member}/>
        </div>
      </div>
    </div>
  );
};

export default MemberDetailsModal;